import BaseApi from './baseApi';
import IGoodsMovementsDetail from '../models/IGoodsMovementsDetail';
import IAuthentication from '../models/IAuthentication';
export default class GoodsMovementsDetailApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Movements");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetGoodsMovementsDetail(movementId : string) : Promise<IGoodsMovementsDetail[]> {
        let json : string = this.getJsonRead(movementId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var goods: IGoodsMovementsDetail[] = [];
            goods = response.data as IGoodsMovementsDetail[];
            return goods;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveGoodsMovementsDetail(good: IGoodsMovementsDetail) : Promise<string> {
        const json = this.getJsonSave(good);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateGoodsMovementsDetail(good: IGoodsMovementsDetail) : Promise<boolean> {
        const json = this.getJsonUpdate(good);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteGoodsMovementsDetail(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteGoodsMovementsDetailByMovementId(goodMovementId: string): Promise<boolean> {
        const json = this.getJsonDeleteByGoodMovementId(goodMovementId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "GoodsMovementsDetail",
            "conditions": [{
                "Item1": "GoodsMovementsDetail",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonDeleteByGoodMovementId(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "GoodsMovementsDetail",
            "conditions": [{
                "Item1": "GoodsMovementsDetail",
                "Item2": "idGoodMovement",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(goodMovementsDetail: IGoodsMovementsDetail) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idGoodsMovement",
                "Item2": goodMovementsDetail.idGoodsMovement
            }, {
                "Item1": "idGood",
                "Item2": goodMovementsDetail.idGood
            }, {
                "Item1": "idListPallet",
                "Item2": goodMovementsDetail.idListPallet
            }, {
                "Item1": "idPallet",
                "Item2": goodMovementsDetail.idPallet
            }, {
                "Item1": "casesPerPallet",
                "Item2": goodMovementsDetail.casesPerPallet
            }, {
                "Item1": "goodsPerCase",
                "Item2": goodMovementsDetail.goodsPerCase
            }, {
                "Item1": "totalGoods",
                "Item2": goodMovementsDetail.totalGoods
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "GoodsMovementsDetail"
        };
        return json;
    }

    private getJsonUpdate(goodMovementsDetail: IGoodsMovementsDetail) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idGoodsMovement",
                "Item2": goodMovementsDetail.idGoodsMovement
            }, {
                "Item1": "idGood",
                "Item2": goodMovementsDetail.idGood
            }, {
                "Item1": "idListPallet",
                "Item2": goodMovementsDetail.idListPallet
            }, {
                "Item1": "idPallet",
                "Item2": goodMovementsDetail.idPallet
            }, {
                "Item1": "casesPerPallet",
                "Item2": goodMovementsDetail.casesPerPallet
            }, {
                "Item1": "goodsPerCase",
                "Item2": goodMovementsDetail.goodsPerCase
            }, {
                "Item1": "totalGoods",
                "Item2": goodMovementsDetail.totalGoods
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "GoodsMovementsDetail",
            "keyvalue": goodMovementsDetail.id
        };
        return json;
    }

    private getJsonRead(movementId : string) : any {
        const json = {
            "fields": [{
                "Item1": "GoodsMovementsDetail",
                "Item2": "id"
            }, {
                "Item1": "GoodsMovementsDetail",
                "Item2": "idGoodsMovement"
            }, {
                "Item1": "GoodsMovementsDetail",
                "Item2": "idGood"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "GoodsMovementsDetail",
                "Item2": "idListPallet"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "Name as listPalletName"
            }, {
                "Item1": "GoodsMovementsDetail",
                "Item2": "casesPerPallet"
            }, {
                "Item1": "GoodsMovementsDetail",
                "Item2": "idPallet"
            }, {
                "Item1": "GoodsMovementsDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "GoodsMovementsDetail",
                "Item2": "totalGoods"
            }, {
                "Item1": "Inbounds",
                "Item2": "code as codeInbounds"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "bestBeforeDate"
            }],
            "tables": [{
                "Item1": "GoodsMovementsDetail"
            }, {
                "Item1": "Goods"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "StockDetail"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDetail"
            }, {
                "Item1": "Inbounds"
            }],
            "joins": [{
                "Item1": "GoodsMovementsDetail",
                "Item2": "idGood",
                "Item3": "Goods",
                "Item4": "Id"
            }, {
                "Item1": "GoodsMovementsDetail",
                "Item2": "idListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdMovementDetail",
                "Item3": "GoodsMovementsDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "Id",
                "Item3": "StockDetail",
                "Item4": "IdInboundDeliveryNoteDetail"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDetail",
                "Item3": "InboundsDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "IdInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "GoodsMovementsDetail",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "GoodsMovementsDetail",
                "Item2": "idGoodsMovement",
                "Item3": "=",
                "Item4": movementId
            }]
        };
        return json;
    }
}
